module.exports = __WEBPACK_EXTERNAL_MODULE_redux_dynamic_modules_core__;